import './banner-intro.scss'

import React from 'react'

import useWindowDimensions from '../../../../hooks/useWindowDimensions'
import { AdaptiveCarousel } from '../../../common/AdaptiveCarousel'
import { Banner } from '../../../sections/Banner'

import type { Intro as BannerIntroProps } from '../../../../types/ClubCard/ClubCardUser'

const LIMIT_IMAGES = 5

export const BannerIntro = ({ visibility, banners }: BannerIntroProps) => {
  const bannersLimited = banners?.slice(0, LIMIT_IMAGES)
  const { width } = useWindowDimensions()
  const isWidthMobile = width && width <= 768
  const sizeItemImage = Math.min(
    (width ?? 0) - 32,
    bannersLimited?.[0]?.width ?? 416
  )

  if (!visibility) {
    return null
  }

  return (
    <div className="club-card-user-bannerIntro grid-content">
      <div className="club-card-user-bannerIntro-container">
        <AdaptiveCarousel
          quantity={bannersLimited?.length}
          quantityToCarousel={!isWidthMobile ? bannersLimited?.length + 1 : 2}
          activeBlur={false}
          propsCarousel={{
            gapItems: 0,
            qtyItems: width && width < 600 ? 1 : 2,
            itemWidthProp: sizeItemImage,
          }}
          isNewDots
        >
          {bannersLimited?.map((itemBanner) => (
            <Banner
              key={itemBanner?.alt}
              data={{
                visibility,
                desktop: itemBanner,
                mobile: itemBanner,
                alt: itemBanner?.alt,
              }}
              className="itemBannerIntro"
            />
          ))}
        </AdaptiveCarousel>
      </div>
    </div>
  )
}
